import React, { ReactNode } from "react";

import { WrappedLink } from "@components/navigation";
import { useAppContext } from "@state/hooks/shared";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";
import { isRegistrationDomain } from "@utils/membership/membershipUtils";

export default function HeaderLogo() {
	return (
		<figure className="header--root__figure">
			<HeaderLogoRedirectWrapper>
				<img
					className="header--root__logo"
					src="/assets/images/logo-negative.svg"
					alt=""
				/>
			</HeaderLogoRedirectWrapper>
		</figure>
	);
}

function HeaderLogoRedirectWrapper(props: { children: ReactNode }) {
	const { culture } = useAppContext();

	const returnUrl = new URL(window.location.href).searchParams.get(
		"returnUrl"
	);

	const homeUrl = returnUrl
		? `/${culture}/${DefaultPath.HOME}?returnUrl=${returnUrl}`
		: `/${culture}/${DefaultPath.HOME}`;

	if (isRegistrationDomain()) {
		return (
			<a
				href={`${WEBPACK_WEBSITE_URL}/${culture}/${DefaultPath.HOME}`}
				className="header--root__figure__link"
			>
				{props.children}
			</a>
		);
	}

	return (
		<WrappedLink to={homeUrl} className="header--root__figure__link">
			{props.children}
		</WrappedLink>
	);
}
